import {Box, Chip, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip, Typography} from "@mui/material";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import EditIcon from '@mui/icons-material/Edit';

const SchedulerSingleLine = ({handleEdit, handleDelete, schedulerData, dayOfWeek }) => {

  if (schedulerData.length === 0) {
    return null;
  }

  return (
    <Box sx={{ mb: 3 }}>
      <Box sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        mb: 1.5
      }}>
        <Typography variant="subtitle2" color="text.secondary" sx={{ fontWeight: 600, fontSize: "0.75rem", textTransform: "uppercase" }}>
          {dayOfWeek}
        </Typography>
        <Chip
          size="small"
          label={schedulerData.length}
          sx={{
            height: 20,
            minWidth: 20,
            fontSize: '0.7rem',
            fontWeight: 600
          }}
        />
      </Box>
      <TableContainer component={Paper} elevation={1}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell sx={{ fontWeight: 600, width: "40%" }}>Feature</TableCell>
              <TableCell sx={{ fontWeight: 600, width: "35%" }}>Days</TableCell>
              <TableCell sx={{ fontWeight: 600, width: "10%" }}>Hour</TableCell>
              <TableCell sx={{ fontWeight: 600, width: "15%" }} align="right">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {schedulerData.map((data, index) => (
              <TableRow key={data.id || index} hover>
                <TableCell>
                  <Typography variant="body2">{data.featureType}</Typography>
                </TableCell>
                <TableCell>
                  <Typography variant="body2" color="text.secondary">
                    {data.dayOfWeek}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography variant="body2" fontWeight={500}>
                    {data.hour}:00
                  </Typography>
                </TableCell>
                <TableCell align="right">
                  <Tooltip title="Edit">
                    <IconButton size="small" onClick={() => handleEdit(data)}>
                      <EditIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Delete">
                    <IconButton size="small" onClick={() => handleDelete(data)} color="error">
                      <DeleteOutlineIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default SchedulerSingleLine;
